import {
  Component,
  Prop,
  h,
  Event,
  type EventEmitter,
  Listen,
  State,
} from '@stencil/core';
import { onNewConversationClickAction, collapseChat } from './mobile-header-helpers';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';

@Component({
  tag: 'uiaas-search-conversational-search-mobile-header',
  styleUrl: 'mobile-header.scss',
  shadow: true,
})
export class ConversationalSearchMobileHeader {
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly query: string;
  @Prop() readonly country: string;
  @Prop() readonly language: string;

  @State() areTermsAccepted: boolean;
  @State() isProcessing: boolean;

  @Event({
    eventName: 'conversational-search:user-new-conversation-trigger',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    userStartingNewConversationEventEmitter: EventEmitter;

  @Event({
    eventName: 'conversational-search:ga-icon-action',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    gaIconEventEmitter: EventEmitter<{ actionItem: string; keyword: string }>;

  @Event({
    eventName: 'conversational-search:chat-visibility',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    chatVisibilityEventEmitter: EventEmitter<{ isChatVisible: boolean }>;

  @Listen('conversational-search:user-question-state', { target: 'window' })
  handleProcessingChange(e) {
      this.isProcessing = e.detail.isProcessing;
  }

  render() {
      const isDisabled = this.isProcessing ? true : void 0;

      return (
        <section class="conversational-search-mobile-header">
          <strong class="conversational-search-mobile-header__text">
            {this.labelProvider('conversational.search.name', 'GenAI Search')}
          </strong>
          <div class="conversational-search-mobile-header__action-items">
            <qds-button
              onClick={() => onNewConversationClickAction(
                this.userStartingNewConversationEventEmitter,
                this.gaIconEventEmitter,
                this.query,
              )}
              importance="subdued"
              icon-name="plus-circle"
              icon-library="default"
              disabled={isDisabled}
              icon-only="true"
            />
            <qds-button
              onClick={() => collapseChat(
                this.gaIconEventEmitter,
                this.chatVisibilityEventEmitter,
                this.query,
              )}
              importance="subdued"
              icon-name="cross-large"
              icon-library="default"
              icon-only="true"
            />
          </div>
        </section>
      );
  }
}
